import { create } from 'zustand';

interface AuthState {
  isLoggedIn: boolean;
  token: string | null;
  login: (token: string) => void;
  logout: () => void;
}

export const useAuthStore = create<AuthState>((set) => ({
  isLoggedIn: !!localStorage.getItem('auth_token'),
  token: localStorage.getItem('auth_token'),
  login: (token) => {
    localStorage.setItem('auth_token', token);
    set({ isLoggedIn: true, token });
  },
  logout: () => {
    localStorage.removeItem('auth_token');
    set({ isLoggedIn: false, token: null });
  },
}));

// 监听token过期事件（API返回401时触发）
if (typeof window !== 'undefined') {
  window.addEventListener('auth-expired', () => {
    useAuthStore.getState().logout();
  });
}
